import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './login-info-display.scss';

/**
 * Login Information Display Component
 * Displays Total sign ins and time spent by a 
 * student for a selected time period 
 */
const LoginInfoDisplay = ({ title, text }) => (
    <div className={css.component}>
        <div className={css.logininfo}>
            <div className={css.title}>{title}</div>
            <div className={css.text}>{text}</div>
        </div>
    </div>
);

LoginInfoDisplay.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string
};

export default styleable(css)(LoginInfoDisplay);



// WEBPACK FOOTER //
// ./components/login-info-display/login-info-display.js